// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const AsymetricalRoundtrip = svgLazyLoader('mobility/asymetrical_roundtrip')
const CarTransport = svgLazyLoader('mobility/car_transport')
const City = svgLazyLoader('mobility/city')
const Duration = svgLazyLoader('mobility/duration')
const ElectricBike = svgLazyLoader('mobility/electric_bike')
const FoldedScooter = svgLazyLoader('mobility/folded_scooter')
const FrequentRoute = svgLazyLoader('mobility/frequent_route')
const FromPin = svgLazyLoader('mobility/from_pin')
const FromStation = svgLazyLoader('mobility/from_station')
const Geolocation = svgLazyLoader('mobility/geolocation')
const GeolocationFull = svgLazyLoader('mobility/geolocation_full')
const Journey = svgLazyLoader('mobility/journey')
const JourneyFull = svgLazyLoader('mobility/journey_full')
const LeaveBikeSharing = svgLazyLoader('mobility/leave_bike_sharing')
const LeaveCarPark = svgLazyLoader('mobility/leave_car_park')
const Map = svgLazyLoader('mobility/map')
const OneOffRoute = svgLazyLoader('mobility/one_off_route')
const PayAsYouGo = svgLazyLoader('mobility/pay_as_you_go')
const PlaceCircleOutline = svgLazyLoader('mobility/place_circle_outline')
const Route = svgLazyLoader('mobility/route')
const Scooter = svgLazyLoader('mobility/scooter')
const Station = svgLazyLoader('mobility/station')
const StationChange = svgLazyLoader('mobility/station_change')
const StationFull = svgLazyLoader('mobility/station_full')
const StationProblem = svgLazyLoader('mobility/station_problem')
const Suitcase = svgLazyLoader('mobility/suitcase')
const SuitcaseFull = svgLazyLoader('mobility/suitcase_full')
const TakeBikeSharing = svgLazyLoader('mobility/take_bike_sharing')
const TakeCarPark = svgLazyLoader('mobility/take_car_park')
const ToStation = svgLazyLoader('mobility/to_station')
const ToStation1 = svgLazyLoader('mobility/to_station1')
const ToStation2 = svgLazyLoader('mobility/to_station2')
const ToStation3 = svgLazyLoader('mobility/to_station3')
const TripsPlanned = svgLazyLoader('mobility/trips_planned')
const ViaStation = svgLazyLoader('mobility/via_station')

const ALL_MOBILITY_ICONS = [
  'asymetrical_roundtrip',
  'car_transport',
  'city',
  'duration',
  'electric_bike',
  'folded_scooter',
  'frequent_route',
  'from_pin',
  'from_station',
  'geolocation',
  'geolocation_full',
  'journey',
  'journey_full',
  'leave_bike_sharing',
  'leave_car_park',
  'map',
  'one_off_route',
  'pay_as_you_go',
  'place_circle_outline',
  'route',
  'scooter',
  'station',
  'station_change',
  'station_full',
  'station_problem',
  'suitcase',
  'suitcase_full',
  'take_bike_sharing',
  'take_car_park',
  'to_station',
  'to_station1',
  'to_station2',
  'to_station3',
  'trips_planned',
  'via_station',
] as const
export type MobilityIcon = (typeof ALL_MOBILITY_ICONS)[number]

const ICONS: LazyIconsGroup<MobilityIcon> = {
  asymetrical_roundtrip: AsymetricalRoundtrip,
  car_transport: CarTransport,
  city: City,
  duration: Duration,
  electric_bike: ElectricBike,
  folded_scooter: FoldedScooter,
  frequent_route: FrequentRoute,
  from_pin: FromPin,
  from_station: FromStation,
  geolocation: Geolocation,
  geolocation_full: GeolocationFull,
  journey: Journey,
  journey_full: JourneyFull,
  leave_bike_sharing: LeaveBikeSharing,
  leave_car_park: LeaveCarPark,
  map: Map,
  one_off_route: OneOffRoute,
  pay_as_you_go: PayAsYouGo,
  place_circle_outline: PlaceCircleOutline,
  route: Route,
  scooter: Scooter,
  station: Station,
  station_change: StationChange,
  station_full: StationFull,
  station_problem: StationProblem,
  suitcase: Suitcase,
  suitcase_full: SuitcaseFull,
  take_bike_sharing: TakeBikeSharing,
  take_car_park: TakeCarPark,
  to_station: ToStation,
  to_station1: ToStation1,
  to_station2: ToStation2,
  to_station3: ToStation3,
  trips_planned: TripsPlanned,
  via_station: ViaStation,
}

export const isMobilityIcon = (mobilityKey: string): mobilityKey is MobilityIcon =>
  ALL_MOBILITY_ICONS.includes(mobilityKey as MobilityIcon)

export const getMobilityIcon = (mobilityKey: MobilityIcon): LazyIcon => ICONS[mobilityKey]

export const getMobilityIcons = (): LazyIconsGroup<MobilityIcon> => ICONS
